import React, { useState } from "react";
import { Calendar } from "react-modern-calendar-datepicker";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import "moment/locale/fa";
import moment from "moment-jalaali";
import { Button, Card, Dialog, useTheme } from "@mui/material";
import FormatHelper from "../helper/FormatHelper";

export default function CalendarModal({
	open,
	setOpen,
	setDate,
	setUnixDate,
	start,
}) {
	const [data, setData] = useState();
	const theme = useTheme();

	return (
		<Dialog open={open} onClose={() => setOpen(false)}>
			<Card
				className="d-flex-column"
				sx={{
					p: 2,
				}}>
				<Calendar
					ClassName="my-cal"
					shouldHighlightWeekends
					locale={"fa"}
					value={data}
					onChange={e => {
						setData(e);
						let selectedDate = FormatHelper.toEnglishString(
							moment(e.day + "/" + e.month + "/" + e.year, "jD/jM/jYYYY").format(
								"jYYYY/jM/jD"
							)
						);
						start
							? setUnixDate(
									FormatHelper.toEnglishString(
										moment(selectedDate, "jYYYY/jM/jD")
											.startOf("day")
											.format("X")
											.toString()
									)
							  )
							: setUnixDate(
									FormatHelper.toEnglishString(
										moment(selectedDate, "jYYYY/jM/jD")
											.endOf("day")
											.format("X")
											.toString()
									)
							  );
					}}
					colorPrimary={theme.palette.primary.main}
				/>
				<Button
					variant="contained"
					sx={{ mt: 1 }}
					onClick={() => {
						setDate(data);
						setOpen(false);
					}}>
					ثبت تاریخ
				</Button>
			</Card>
		</Dialog>
	);
}
